import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ClearwaterTransaction } from '../models/clearwater-transaction.model'
import { ExternalTransaction } from '../models/external-transaction.model'

const TRANSACTION_DETAIL_HOST = `helios-transaction-details`
const TRANSACTION_MATCHES_URL = `${TRANSACTION_DETAIL_HOST}/transactions/{UUID}/externalTransactions`
const TRANSACTION_DETAIL_URL = `${TRANSACTION_DETAIL_HOST}/transactions/`
const EXTERNAL_TRANSACTION_DETAIL_URL = `${TRANSACTION_DETAIL_HOST}/externalTransaction/`

@Injectable({
  providedIn: 'root',
})
export class TransactionDetailService {
  constructor(private readonly httpClient: HttpClient) {}

  loadTransactionMatches(
    transactionId: string,
  ): Observable<{ [s: string]: ExternalTransaction }> {
    return this.httpClient.get<{ [s: string]: ExternalTransaction }>(
      TRANSACTION_MATCHES_URL.replace('{UUID}', transactionId),
    )
  }

  loadExternalUnmatchedTransaction(
    transactionId: number,
  ): Observable<ExternalTransaction> {
    return this.httpClient.get<ExternalTransaction>(
      EXTERNAL_TRANSACTION_DETAIL_URL + transactionId,
    )
  }

  loadTransaction(transactionId: string): Observable<ClearwaterTransaction> {
    return this.httpClient.get<ClearwaterTransaction>(
      TRANSACTION_DETAIL_URL + transactionId,
    )
  }
}
